const extractDescription = (interfaceName, texto) => {
  return texto
    ?.split(interfaceName)[1]
    ?.replace(/\s*[-,]\s*(Lane|Ramo).*/gi, "")
    ?.replace(" - ", "")
    ?.replace(" -", "");
};
export default extractDescription;
